import { defaultLanguage } from "src/utils/Translations/translationUtils";

const changeMetaLang = (lang, defaultLang = defaultLanguage) => {
  const appDocument = document?.documentElement;

  switch (lang) {
    case "en":
      appDocument.setAttribute("lang", "en");
      break;
    case "pl":
      appDocument.setAttribute("lang", "pl");
      break;
    default:
      appDocument.setAttribute("lang", defaultLang);
  }
};

export default changeMetaLang;
